import PropTypes from 'prop-types';
// material
import { alpha, styled } from '@mui/material/styles';
import { Box, Stack, AppBar, Toolbar, IconButton } from '@mui/material';
// components
import Iconify from '../../componentes/Iconify';
//
import AccountPopover from './AccountPopover';

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280;
const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 92;

const RootStyle = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== 'isDesktopSidebarOpen'
})(({ theme, isDesktopSidebarOpen }) => ({
  boxShadow: 'none',
  zIndex: 9,
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
  backgroundColor: alpha(theme.palette.background.default, 0.72),
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  [theme.breakpoints.up('lg')]: {
    width: isDesktopSidebarOpen ? `calc(100% - ${DRAWER_WIDTH + 1}px)` : '100%'
  }
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 3)
  }
}));

// ----------------------------------------------------------------------

DashboardNavbar.propTypes = {
  onToggleSidebar: PropTypes.func,
  isDesktopSidebarOpen: PropTypes.bool
};

export default function DashboardNavbar({ onToggleSidebar, isDesktopSidebarOpen }) {
  return (
    <RootStyle isDesktopSidebarOpen={isDesktopSidebarOpen}>
      <ToolbarStyle>
        <IconButton
          onClick={onToggleSidebar}
          sx={{ mr: 1, color: 'text.primary' }}
          title={isDesktopSidebarOpen ? 'Ocultar menú lateral' : 'Mostrar menú lateral'}
        >
          <Iconify icon="eva:menu-2-fill" width={24} height={24} />
        </IconButton>
        <Box sx={{ flexGrow: 1 }} />

        <Stack direction="row" alignItems="center" spacing={{ xs: 0.5, sm: 1.5 }}>
          <AccountPopover />
        </Stack>
      </ToolbarStyle>
    </RootStyle>
  );
}
